import { render, staticRenderFns } from "./NewDiscardChangesModal.vue?vue&type=template&id=4cac0c4a&scoped=true&"
import script from "./NewDiscardChangesModal.vue?vue&type=script&lang=js&"
export * from "./NewDiscardChangesModal.vue?vue&type=script&lang=js&"
import style0 from "./NewDiscardChangesModal.vue?vue&type=style&index=0&id=4cac0c4a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cac0c4a",
  null
  
)

export default component.exports